/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  withStyles, Paper, FormControl, InputLabel, MenuItem, Select, Typography, TextField, Tooltip,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';

import { multiTemplateValidationSchema } from '../utils/util';
import MultiTemplateDay from '../components/multiTemplateDay';
import ScrollContainer from '../components/ScrollContainer';
import Drawer from '../components/Drawer';
import Actions from '../actions';

const styles = (theme) => {
  return {
    root: {
      width: '100%',
    },
    days: {
      width: '100%',
      marginTop: theme.spacing(1),
    },
    selectTemplate: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-around',
      margin: theme.spacing(1),
      padding: theme.spacing(1),
      alignItems: 'center',
    },
  };
};

class MultiTemplate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeMultiTemplate: '',
      editing: true,
    };
  }

  componentDidMount() {
    this.props.fetchMultiTemplates();
    this.props.fetchTaskTemplates();
  }

  createNewTemplate= () => {
    this.setState({
      activeMultiTemplate: 'NewTemplate',
      name: '',
      days: [],
    });
  }
  resetState= () => {
    this.setState({
      activeMultiTemplate: '',
      name: '',
      days: [],
    });
  }

  setMultiTemplate = (event) => {
    const multiTemplate = event.target.value;
    this.setState({
      activeMultiTemplate: multiTemplate,
      name: multiTemplate.name,
      days: multiTemplate.days,
      editing: false,
    });
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  addTemplate = (template, index) =>{
    this.setState((prevState)=>{
      const days = prevState.days;
      const day = days[index];
      day.push(template);
      days[index] = day;
      return {...prevState, days};
    })
  }

  removeTemplate = (templateidx, index) =>{
    this.setState((prevState)=>{
      const days = prevState.days;
      const day = days[index];
      day.splice(templateidx,1);
      days[index] = day;
      return {...prevState, days};
    })
  }

  handleSubmit = (e) =>{
    e.preventDefault();
    if(this.state.name === '' || this.state.activeMultiTemplate === ''){
      return alert('please Add Name');
    }
    if(typeof this.state.days === 'undefined' && this.state.days.length === 0){
      return alert('Please add atleast 1 day and templates')
    }
    const data = {
      name:this.state.name,
      days:this.state.days,
    }
    if(this.state.activeMultiTemplate !== 'NewTemplate'){
      data._id = this.state.activeMultiTemplate._id;
      return multiTemplateValidationSchema.validate(data)
      .then(() => {
        return this.props.editMultiTemplate(data)
          .then(() => {
            alert(`MultiTemplate updated Successfully!! \n Data: ${JSON.stringify(data)}`);
            this.resetState();
          });
      })
      .catch((err) => { return alert(err); });
    }
    else{
      return multiTemplateValidationSchema.validate(data)
      .then(() => {
        return this.props.addMultiTemplate(data)
          .then(() => {
            alert(`MultiTemplate Added Successfully!! \n Data: ${JSON.stringify(data)}`);
            this.resetState();
          });
      })
      .catch((err) => { return alert(err); });
    }
  }

  keyPressed = (event) => {
    if (this.state.name?.length > 0 && event.charCode === 13) this.setState({ editing: false });
  }

  addDay = () => {
    this.setState((prevState)=>{
      const days = prevState.days;
      days.push([]);
      return {...prevState, days};
    });
  }

  render() {
    const { classes } = this.props;
    return (
      <Drawer>
        <ScrollContainer>
          <div className={classes.root}>
            <Paper className={classes.selectTemplate}>
              <FormControl variant="outlined" style={{ width: 250 }}>
                <InputLabel id="demo-simple-select-filled-label">MultiTemplates</InputLabel>
                <Select
                  labelId="demo-simple-select-filled-label"
                  label ="MultiTemplates"
                  id="demo-simple-select-filled"
                  value={this.state.activeMultiTemplate}
                  onChange={this.setMultiTemplate}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value="NewTemplate" disabled>
                    <em>Creating Template</em>
                  </MenuItem>
                  {
                this.props.multiTemplates && this.props.multiTemplates.map(
                  (multiTemplate) => {
                    return (<MenuItem key={multiTemplate._id} value={multiTemplate}>{multiTemplate.name}</MenuItem>);
                  },
                )
              }
                </Select>
              </FormControl>
              <Typography variant="h5">
                OR
              </Typography>
              <Button variant="contained" color="primary" onClick={this.createNewTemplate}>
                Create A new Template
              </Button>
            </Paper>
            {
              this.props.fetchingData
                ? (
                  <div
                    elevation={0}
                    style={{
                      height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center',
                    }}
                  >
                    <img
                      // eslint-disable-next-line global-require
                      src={require('../assets/images/loading.gif')}
                      alt="loading"
                    />
                  </div>
                )
                : this.state.activeMultiTemplate !== ''
                  ? (
                    <div className={classes.days}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          {/* <span style={{color: '#333', marginRight: '8px', fontSize: '16px', fontWeight: 'bold'}}>Add Day</span> */}
                          <Fab style={{ background: '#583c5c', color: '#fff' }} onClick={this.addDay} aria-label="add-day">
                            <AddIcon />
                          </Fab>
                        </div>
                        <Tooltip
                          title="Double click to edit name"
                          placement="bottom-end"
                        >
                          <div
                            style={{ flexGrow: 1, display: 'flex', justifyContent: 'flex-end' }}
                            onDoubleClick={() => { return this.setState({ editing: true }); }}
                          >
                            {this.state.editing || this.state.name === ''
                              ? (
                                <FormControl style={{ width: 250 }}>
                                  <TextField
                                    value={this.state.name}
                                    variant="outlined"
                                    id="name"
                                    name="name"
                                    label="Template Name"
                                    onKeyPress={this.keyPressed}
                                    onChange={this.handleChange}
                                  />
                                </FormControl>
                              )
                              : <h3>{ this.state.name }</h3>}
                          </div>
                        </Tooltip>
                      </div>
                      <div style={{ marginTop: 20 }}>
                        {
                      this.state.days?.map((val, index) => {
                        const key=`Day_${index}`;
                        return (
                          <div key={key}>
                            <div style={{ textAlign: 'left' }}>
                              <h3>
                                Day:
                                {index}
                              </h3>
                            </div>
                            <div>
                              <MultiTemplateDay 
                              templates={val} 
                              allTemplates={this.props.taskTemplates} 
                              addTemplate={(template)=>this.addTemplate(template,index)}
                              removeTemplate={(templateidx)=>this.removeTemplate(templateidx,index)}
                              />
                            </div>
                          </div>
                        );
                      })
                  }
                      </div>
                    </div>
                  ) : <p>Please Select Template or create one</p>
              }
            {
                this.state.days?.length > 0
                  ? (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        {/* <span style={{color: '#333', marginRight: '8px', fontSize: '16px', fontWeight: 'bold'}}>Add Day</span> */}
                        <Fab style={{ background: '#583c5c', color: '#fff' }} onClick={this.addDay} aria-label="add-day">
                          <AddIcon />
                        </Fab>
                      </div>
                    </div>
                  ) : null
            }
            {
                this.state.days?.length > 0
                  ? (
                    <div style={{ margin: 50 }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={this.handleSubmit}
                      >
                        Submit
                      </Button>
                    </div>
                  ) : null
            }
          </div>
        </ScrollContainer>
      </Drawer>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    taskTemplates: state.taskTemplate.data,
    multiTemplates: state.multiTemplate.data,
    fetchingData: state.multiTemplate.fetching
            || state.taskTemplate.fetching,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MultiTemplate)));
